module.exports = __webpack_public_path__ + "img/zhuanjiatouxiang.c794dd71.png";